// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_DesfazerContatoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /retomada/desfazer_contato (chamado 2026-0052): apaga um contato de retomada
 * marcado por engano. A linha volta a PENDENTE e o contato sai da contagem do dia.
 */
import { registerContract } from './validate'

export interface Retomada_DesfazerContatoInput {
contato_id: number
}

registerContract('Retomada_DesfazerContatoInput', {
  contato_id: { type: 'number',  required: true },
})
